/**
 * Storage & Integration Service
 * Manages local persistence and remote webhook registration for pre-orders.
 */

export class StorageService {
  private static readonly STORAGE_KEY = "cancelled_registered_emails";

  public isValidEmail(email: string): boolean {
    const clean = email.trim();
    return clean.length >= 5 && clean.includes("@") && clean.includes(".");
  }

  public saveEmailLocally(email: string): boolean {
    const clean = email.trim().toLowerCase();
    if (!this.isValidEmail(clean)) return false;

    try {
      const raw = localStorage.getItem(StorageService.STORAGE_KEY);
      const list: string[] = raw ? (JSON.parse(raw) as string[]) : [];
      if (!list.includes(clean)) {
        list.push(clean);
        localStorage.setItem(StorageService.STORAGE_KEY, JSON.stringify(list));
      }
      return true;
    } catch {
      return false;
    }
  }

  public async postToEndpoint(endpoint: string, email: string): Promise<boolean> {
    const clean = email.trim().toLowerCase();
    if (!endpoint || !this.isValidEmail(clean)) return false;

    try {
      const res = await fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: clean,
          timestamp: new Date().toISOString(),
          source: "cancelled-app"
        })
      });
      return res.ok;
    } catch {
      return false;
    }
  }
}
